import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  gql,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_URL_GRAPH,
});

const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      "X-API-KEY": process.env.REACT_APP_APIKEY_GRAPH,
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export const subscribeOnCreate = () => {
  const subscriptionOnCreate = gql`
subscription MySubscription {
    onCreateLeads {
      CommentManage
      NameManager
      Who
      advicer
      birth
      branch
      channel
      comments
      conekta
      curp
      dateAsignation
      dateManager
      dateAtencion
      dateRegistry
      detail
      email
      fase
      firstLastName
      id
      idAdvicer
      idBranch
      idEvent
      idManager
      isContacted
      isReassigned
      name
      phone1
      secondLastName
      status
    }
  }`;

  client.subscribe({ query: subscriptionOnCreate }).subscribe({
    next(response) {
      console.log("Datos recibidos:", response.data);
      // Aquí puedes realizar las acciones necesarias con los datos recibidos
    },
    error(error) {
      console.error("Error en la suscripción:", error);
    },
  });
};
